import React, {useContext} from 'react';
import {injectIntl} from "react-intl";
import FormContext from "formContext";
import SelectField from "@FormElements/SelectField";
const toLowerCase = require('@toLowerCase');

function RegionSelectField({intl, settings, ...rest}) {
  const {additionalData: {regions}} = useContext(FormContext);

  const RegionField = () => {
    if (!regions || !Object.keys(regions).length) {
      return null;
    }
    const regionOptions = [];
    regionOptions.push({ value: "", label: intl.formatMessage({id: 'SelectField.EmptyOption.Label'}) });
    regions.forEach((region) => {
      regionOptions.push({
        value: toLowerCase(region),
        label: toLowerCase(region),
      });
    });

    settings.options = regionOptions;

    return (
      <SelectField
        settings={settings}
        {...rest}
      />
    )
  };


  return (
    <>
      <RegionField />
    </>
  )
}

export default injectIntl(RegionSelectField);
